import { ReportProgressCallback, uploadVendorItemCatalogSyncData } from "@/lib/gas-api";

const vendorItemCatalogExportUrl =
  "https://legacy.sosinventory.com/ReportV2/GetReportCSV?reportType=ExportVendorItemCatalog&settings=exportformat=csv|showdeleted=1|showarchived=1|&fields=Vendor,Item,Price,VendorPartNumber,";

export async function runVendorItemCatalogSync(reportProgress: ReportProgressCallback) {
  // Get CSV contents of the Vendor-Item catalog export from SOS
  reportProgress("Fetching Vendor-Item Catalog data from SOS...");
  let response;
  try {
    response = await fetch(vendorItemCatalogExportUrl, { redirect: "manual" });
  } catch (error) {
    // If the user does not have the SOS Fixer extension installed, the fetch request will fail due to CORS limitations
    // The browser extension forges the 'Referer' request header and the 'access-control-allow-origin' response header to make the CORS request succeed
    throw new Error(
      "An error occurred when fetching the Vendor-Item Catalog from SOS. Please ensure you have the 'SOS Fixer' browser extension installed and then try again.",
      { cause: error },
    );
  }

  // Throw an error if the user is not logged in to SOS. In this case, the request will return a 302 redirect to the login page
  // NOTE: It is not possible to check the 'Location' header when blocking redirects using `redirect: "manual"`, so we
  // just have to assume that every 302 response is a redirect to the SOS login page
  // See: https://github.com/whatwg/fetch/issues/763
  if (response.type === "opaqueredirect")
    throw new Error("Please open SOS in a new tab, log in to your account, and then try again.");

  if (!response.ok) throw new Error(`Failed to fetch Vendor-Item Catalog export: ${response.statusText}`);

  const csvText = await response.text();

  // Submit the BOM data to the supabase database
  reportProgress("Uploading Vendor-Item Catalog data to database...");
  await uploadVendorItemCatalogSyncData(reportProgress, csvText);
}
